import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const AccountsLayout = () => {
  const navList = useNav();
  let {accountBottomNav, topAccountNav} = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={accountBottomNav} topTabs={topAccountNav} />
      <Outlet />
    </div>
  )
}

export default AccountsLayout;